import { MapModel } from "src/app/shared/components/molecules/map/model/map-model";

export interface PotentialCustomer {
    location: MapModel,
    fantasyName: string,
    //comments: string,
    zipCodeManual?: boolean,
}

export interface MapConfirmationDto {
coordinates: Coordinates,
noneNumber: boolean,
street: string,
streetNumber: number,
}

export interface Coordinates {
    lon: number,
    lat: number
}


export interface Atribute {
    value: number,
    attributeName: string, 
    attributeId: number;
};
